import React, { Component } from "react";

class JobForm extends Component {
  state = {
    job: this.props.job
  };

  handleJobChange = (key, value) => {
    const { job } = this.state;
    const newJob = { ...job, [key]: value };

    this.setState({ job: newJob });
  };

  render() {
    const { job } = this.state;
    const { userType } = this.props;
    const disabled = userType === "admin" ? "" : "disabled";

    if (!job) {
      return;
    }

    const address = job.address.toString().replace(/\s/g, "+");
    const postalCode = job.postal_code.toString().replace(/\s/g, "+");

    const link = `https://www.google.ca/maps/place/${address}+${postalCode}`;

    return (
      <div className="details">
        <div className="row">
          <p className="col-md-12 job">
            <label className="control-label">Client :</label>
            <input
              type="text"
              name="client"
              id="client"
              value={job.client}
              disabled={disabled}
              onChange={e => this.handleJobChange("client", e.target.value)}
            />
          </p>
          <p className="col-md-12 job">
            <label className="control-label">No client :</label>
            <input
              type="text"
              name="code_casa"
              id="code_casa"
              value={job.code_casa}
              disabled={disabled}
              onChange={e => this.handleJobChange("code_casa", e.target.value)}
            />
          </p>
          <div className="col-md-12 job address-row">
            <div className="address-label-container">
              <label className="control-label">Adresse :</label>
              <a
                className="map-address"
                rel="noopener noreferrer"
                target="_blank"
                href={link}
              >
                <img
                  height="50"
                  alt="Google Map Icon"
                  src="https://www.gstatic.com/images/branding/product/1x/maps_64dp.png"
                />
              </a>
            </div>
            <div className="address-container">
              <p>
                <input
                  type="text"
                  name="address"
                  id="address"
                  placeholder="ADRESSE"
                  value={job.address}
                  disabled={disabled}
                  onChange={e =>
                    this.handleJobChange("address", e.target.value)
                  }
                />
              </p>
              <p>
                <input
                  type="text"
                  name="city"
                  id="city"
                  placeholder="VILLE, PROVINCE"
                  value={job.city}
                  disabled={disabled}
                  onChange={e => this.handleJobChange("city", e.target.value)}
                />
              </p>
              <p>
                <input
                  type="text"
                  name="postal_code"
                  id="postal_code"
                  placeholder="CODE POSTAL"
                  value={job.postal_code}
                  disabled={disabled}
                  onChange={e =>
                    this.handleJobChange("postal_code", e.target.value)
                  }
                />
              </p>
            </div>
          </div>

          <p className="col-md-12 job">
            <label className="control-label">Temps Google :</label>
            <input
              type="text"
              name="distance"
              id="distance"
              value={job.distance}
              disabled={disabled}
              placeholder="00h00"
              maxLength="5"
              onChange={e => this.handleJobChange("distance", e.target.value)}
            />
          </p>
        </div>
        <div className="row">
          <p className="col-md-12 job">
            <label className="control-label">Contact :</label>
            <input
              type="text"
              name="contact"
              id="contact"
              value={job.contact}
              disabled={disabled}
              onChange={e => this.handleJobChange("contact", e.target.value)}
            />
          </p>
          <p className="col-md-12 job">
            <label className="control-label">Email :</label>
            <input
              type="text"
              name="email"
              id="email"
              value={job.email}
              disabled={disabled}
              onChange={e => this.handleJobChange("email", e.target.value)}
            />
          </p>
          <p className="col-md-12 job">
            <label className="control-label">Téléphone :</label>
            <input
              type="text"
              name="phone"
              id="phone"
              value={job.phone}
              disabled={disabled}
              onChange={e => this.handleJobChange("phone", e.target.value)}
            />
          </p>
          <p className="col-md-12 job">
            <label className="control-label">Mobile :</label>
            <input
              type="text"
              name="mobile_phone"
              id="mobile_phone"
              value={job.mobile_phone}
              disabled={disabled}
              onChange={e =>
                this.handleJobChange("mobile_phone", e.target.value)
              }
            />
          </p>
          <p className="col-md-12 job">
            <label className="control-label">Contacté :</label>
            <input
              id="contacted"
              type="checkbox"
              name="contacted"
              checked={job.contacted}
              disabled={disabled}
              onChange={e =>
                this.handleJobChange("contacted", e.target.checked)
              }
            />
          </p>
        </div>
        <div className="row">
          <p className="col-md-12 job">
            <label className="control-label">Référence :</label>
            <input
              type="text"
              name="reference"
              id="reference"
              value={job.reference}
              disabled={disabled}
              onChange={e => this.handleJobChange("reference", e.target.value)}
            />
          </p>
          <p className="col-md-12 job">
            <label className="control-label">Représentant :</label>
            <input
              type="text"
              name="representant"
              id="representant"
              value={job.representant}
              disabled={disabled}
              onChange={e =>
                this.handleJobChange("representant", e.target.value)
              }
            />
          </p>
        </div>
        <div className="row">
          <p className="col-md-12 job">
            <label className="control-label">Projet :</label>
            <input
              type="text"
              name="prd_id"
              id="prd_id"
              value={job.prd_id}
              disabled={disabled}
              onChange={e => this.handleJobChange("prd_id", e.target.value)}
            />
          </p>
          <p className="col-md-12 job">
            <label className="control-label">Séquence :</label>
            <input
              type="text"
              name="sequence"
              id="sequence"
              value={job.sequence}
              disabled={disabled}
              onChange={e => this.handleJobChange("sequence", e.target.value)}
            />
          </p>

          <p className="col-md-12 job">
            <label className="control-label">Étape :</label>
            <input
              type="text"
              name="step"
              id="step"
              value={job.step}
              disabled={disabled}
              onChange={e => this.handleJobChange("step", e.target.value)}
            />
          </p>
          <p className="col-md-12 job">
            <label className="control-label">Description :</label>
            <input
              type="text"
              name="description"
              id="description"
              value={job.description}
              disabled={disabled}
              onChange={e =>
                this.handleJobChange("description", e.target.value)
              }
            />
          </p>

          <p className="col-md-12 job">
            <label className="control-label">Ressource :</label>
            <input
              type="text"
              name="resource"
              id="resource"
              disabled={disabled}
              value={job.resource}
              onChange={e => this.handleJobChange("resource", e.target.value)}
            />
          </p>
          <p className="col-md-12 job">
            <label className="control-label">Note :</label>
          </p>
          <p className="col-md-12 job">
            <textarea
              id="job_note"
              value={job.note}
              disabled={disabled}
              onChange={e => this.handleJobChange("note", e.target.value)}
            />
          </p>
        </div>
      </div>
    );
  }
}

export default JobForm;
